// const API_URL = import.meta.env.VITE_API_URL;

export const routes = {
  // API_URL: "https://kaushikoutdoors.com",
  API_URL: import.meta.env.VITE_API_URL,
  TOKEN: import.meta.env.VITE_TOKEN,
  LOGOUT: "/web_apis/logout",
  LOGIN: "/web_apis/login",
  MEDIUM: "/web_apis/medium",
  FILTER: "/web_apis/filter",
};
